import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { getApiUrl } from '../../utils/api';
import { LieuxServices } from './LieuxServices';

const API = getApiUrl();

/* LOT 81 · Bloc 2 · remplace l'ancienne « MomentsDialog » (Finance › Services, carte ⋯ › Lieux et services) :
   un seul écran de réglage des lieux et services (K1), ouvert en pop-up sur l'écran en cours.
   Props compatibles avec l'ancien composant : `onClose`, `onSaved` (le prop `moments` n'est plus utilisé, l'écran relit lui-même sa source unique).
   `onSaved` n'est appelé qu'à la fermeture (comme l'ancien bouton « Enregistrer »), jamais après chaque champ : la pop-up reste ouverte pendant toute l'édition. */
export const LieuxServicesDialog = ({ onClose, onSaved }) => {
  const [d, setD] = useState(null);
  const reload = () => axios.get(`${API}/finance-hub/reglages-ig`, { withCredentials: true }).then((r) => setD(r.data)).catch(() => toast.error('Lieux indisponibles'));
  useEffect(() => { reload(); }, []);
  const save = async (body) => { try { const r = await axios.put(`${API}/finance-hub/reglages-ig`, body, { withCredentials: true }); setD(r.data); } catch (err) { toast.error(err?.response?.data?.detail || 'Enregistrement impossible'); } };
  const fermer = () => { onSaved?.(); onClose?.(); };
  return <Dialog open onOpenChange={(o) => { if (!o) fermer(); }}>
    <DialogContent data-testid="lieux-services-dialog" closeTestId="lieux-services-dialog-close" aria-describedby={undefined} overlayClassName="z-[1300]" className="z-[1300] max-w-2xl w-[calc(100%-24px)] max-h-[85dvh] overflow-y-auto bg-[var(--carte)]">
      <DialogHeader><DialogTitle>Lieux et services</DialogTitle></DialogHeader>
      {!d ? <div className="bg-[var(--remplissage)] rounded-xl h-24 animate-pulse" data-testid="lieux-services-dialog-chargement" /> : <LieuxServices d={d} save={save} reload={reload} />}
    </DialogContent>
  </Dialog>;
};
